import { usePopup } from '@/contexts/PopupContext';
import { ArrowRight } from 'lucide-react';

export default function CTABanner({ showChat = false }) {
  const { openPopup } = usePopup();

  return (
    <section className="py-20 lg:py-24 relative overflow-hidden" data-testid="cta-banner">
      <div className="absolute inset-0 z-0">
        <img
          src="/assets/img/bg-cta.jpg"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[#064E3B]/90" />
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-5">
          Your Brand Won't Protect Itself. Let's Fix That.
        </h2>
        <p className="text-emerald-200 text-base lg:text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          Every day without trademark protection is a day your brand is at risk. Take the first step toward securing your intellectual property with a free consultation.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => openPopup()}
            className="bg-white text-[#064E3B] px-8 py-3.5 rounded-full font-semibold text-sm hover:bg-emerald-50 transition-colors flex items-center gap-2 btn-pulse"
            data-testid="cta-register-btn"
          >
            Register My Trademark
            <ArrowRight className="w-4 h-4" />
          </button>
          {showChat && (
            <button
              className="border-2 border-white text-white px-8 py-3.5 rounded-full font-semibold text-sm hover:bg-white/10 transition-colors"
              data-testid="cta-chat-btn"
              id="chat-now-btn-cta"
            >
              Chat Now
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
